import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DirectieCompartimenteService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.directieCompartimente.changeStatusDirectieCompartimenteActive;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.dgitl.nomenclatoare.directieCompartimente.changeStatusDirectieCompartimentePublic;

    constructor(private http: HttpClient) { }

    changeStatuseActive(id: number) {
        return this.http.get(this.changeStatusActiveUrl + id, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.get(this.changeStatusPublicUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
